import { ILangText } from "../ILangText";
import { session } from "./session";
import { assets } from "./assets";
import { prompts } from "./prompts";
import { studies } from "./studies";
import { nav } from "./nav";
import { form } from "./form";
import { tags } from "./tags";
import { widgets } from "./widgets";
import { global } from "./global";

export const dictionary:{ [k:string]:ILangText }  = {
	...global,
	...form,
	...studies,
	...session,
	...assets,
	...prompts,
	...nav,
	...tags,
	...widgets,
}